import { Autocomplete, TextField } from '@mui/material';
import { DEVICE_ACTIVE, DEVICE_CREATED } from '../@types/model/device';
// import { DEVICE_ACTIVE, DEVICE_CREATED, DEVICE_TO_BE_DELETED } from '../@types/model/device';
import { useTranslation } from 'react-i18next';

interface DeviceStatePickerProps {
  selection: string;
  changeHandler: (selection: string) => void;
}

const DeviceStatePicker = (props: DeviceStatePickerProps) => {
  const { t } = useTranslation();
  const values = [
    {
      label: 'any_state',
      value: 'any'
    },
    {
      label: 'state_active',
      value: DEVICE_ACTIVE
    },
    {
      label: 'state_inactive',
      value: DEVICE_CREATED
    } /*,
    {
      label: 'state_to_be_deleted',
      value: DEVICE_TO_BE_DELETED
    }*/
  ];
  return (
    <Autocomplete
      disablePortal
      sx={{ minWidth: '200px' }}
      autoHighlight
      value={values.find((state) => state.value === props.selection)}
      options={values}
      onChange={(event, values) => {
        if (values) {
          props.changeHandler(values.value);
        } else {
          props.changeHandler('any');
        }
      }}
      getOptionLabel={(option) => {
        return t(option.label);
      }}
      renderOption={(props, option) => (
        <li key={option.value} {...props}>
          {t(option.label)}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('state')}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
        />
      )}
    />
  );
};

export default DeviceStatePicker;
